<template>
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.9398 37.3515C32.0381 35.177 38 27.7848 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 27.7848 5.96187 35.1771 14.0602 37.3515L18.9999 44L23.9398 37.3515Z" fill="#231F20"/>
    <path d="M10.75 18C10.75 17.3096 11.3096 16.75 12 16.75H22C22.6904 16.75 23.25 17.3096 23.25 18V25C23.25 25.6904 22.6904 26.25 22 26.25H12C11.3096 26.25 10.75 25.6904 10.75 25V18ZM25.75 19.8639C25.75 19.3618 26.0505 18.9084 26.513 18.7127L29.9026 17.2787C30.0674 17.2089 30.25 17.3299 30.25 17.5089V25.4911C30.25 25.6701 30.0674 25.7911 29.9026 25.7213L26.513 24.2873C26.0505 24.0916 25.75 23.6382 25.75 23.1361V19.8639ZM24.25 11.5C24.25 13.0188 23.0188 14.25 21.5 14.25C19.9812 14.25 18.75 13.0188 18.75 11.5C18.75 9.98122 19.9812 8.75 21.5 8.75C23.0188 8.75 24.25 9.98122 24.25 11.5ZM16.25 11.5C16.25 13.0188 15.0188 14.25 13.5 14.25C11.9812 14.25 10.75 13.0188 10.75 11.5C10.75 9.98122 11.9812 8.75 13.5 8.75C15.0188 8.75 16.25 9.98122 16.25 11.5Z" stroke="white" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaIconCamera'
}
</script>

<style scoped>

</style>
